import { useLocation, useNavigate } from "react-router-dom";
import {
  GeneralSidebarSettingItems,
  SidebarSettingsItem,
  UserSidebarSettingItems,
} from "../../constant/data";
import { Settings } from "../../pages/home/Settings";
import NavigatebackBtn from "../generic/NavigateBackBtn";
import React, { useEffect, useState } from "react";
import { SidebarItemsDTO } from "../../typings/uicomponents";
import useDepartmentHook from "../../hooks/useDepartmentHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { HiOutlineChevronDown } from "react-icons/hi2";

const SidebarNav: React.FC<SidebarItemsDTO> = ({ items, title }) => {
  const navigate = useNavigate();
  const { selectedOrgDepts } = useDepartmentHook();
  const { setLoading } = useStateSetter();
  const [active, setactive] = useState(items[0]?.title);
  
  let [showchildren, setshowchildren] =useState(false)

  useEffect(() => {
    items[0]?.onclick();
    setactive(items[0]?.title);
  }, [selectedOrgDepts]);

  useEffect(() => {
    if (!items) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className="bg-white   max-h-[80vh] p-4 rounded-[20px] overflow-y-scroll overflow-x-hidden">
      <div className="py-4">
        <NavigatebackBtn
          style={"inline mr-2 "}
          onclick={() => {
            navigate(-1);
          }}
        />
        <p className="font-medium text-gray-700 inline ">{title}</p>
      </div>
      {items.map((item: any) =>{
        
        return(
        <div>
          <p
            className={` p-3  m-2 cursor-pointer text-sm  rounded-[10px] capitalize  truncate ${
              active == item.title ? "bg-faint text-primary" : "text-textbg "
            } font-medium`}
            onClick={() => {
              setactive(item.title);
              item.onclick();
             item.children&& setshowchildren((prev)=>!prev)
            }}
          >
            {item.icon}
            {item.title} {
              item.children &&                 <HiOutlineChevronDown className="text-textbg inline " />

            }
          </p>

          {item.children?.map((it:any) => ( showchildren&&
            <div className=" ml-6">
              <p
                className={` p-3  m-2 cursor-pointer text-xs  rounded-[10px] capitalize  self-end truncate ${
                  active == it.title
                    ? "bg-faint text-primary"
                    : "text-textbg "
                } font-medium`}
                onClick={() => {
                  setactive(it.title);
                  it.onclick();
                }}
              >
             
                {it.title}
              </p>
            </div>
          ))}
        </div>
      )
      }
      
      )}
    </div>
  );
};

export default SidebarNav;
